import helpers from './helpers';

export default {
  getNewDiff: (state, getters) => helpers.getNewDiff,
};
